import './App.scss';
import {About, Footer, Header, Testimonials, Work, Skills} from "./containers";
import {Navbar} from "./components";
import {useEffect} from "react";

function App() {
    return (
        <div className="app">
            <Navbar/>
            <Header/>
            <About/>
            <Work/>
            <Skills/>
            <Testimonials/>
            <Footer/>
        </div>
    );
}

export default App;
